import { CONTACTS } from "@/lib/content";

let fontsPromise;

const toBase64 = async (url) => {
  const buf = await (await fetch(url)).arrayBuffer();
  let bin = "";
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(bin);
};

const loadFonts = () => {
  if (!fontsPromise) {
    fontsPromise = Promise.all([toBase64("/fonts/IBMPlexSans-Regular.ttf"), toBase64("/fonts/IBMPlexSans-SemiBold.ttf")]);
  }
  return fontsPromise;
};

export const downloadCalcPdf = async ({ title, resultLabel, mainText, rows, note, meta, lang }) => {
  const [{ jsPDF }, [regular, semibold]] = await Promise.all([import("jspdf"), loadFonts()]);
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  doc.addFileToVFS("Plex-Regular.ttf", regular);
  doc.addFileToVFS("Plex-SemiBold.ttf", semibold);
  doc.addFont("Plex-Regular.ttf", "Plex", "normal");
  doc.addFont("Plex-SemiBold.ttf", "Plex", "bold");

  const W = 210;
  const M = 18;
  const gold = [203, 163, 101];
  const ink = [10, 10, 12];
  const dim = [110, 110, 118];

  doc.setFillColor(...ink);
  doc.rect(0, 0, W, 34, "F");
  doc.setFont("Plex", "bold");
  doc.setFontSize(18);
  doc.setTextColor(...gold);
  doc.text("RightAccount", M, 16);
  doc.setFont("Plex", "normal");
  doc.setFontSize(9);
  doc.setTextColor(200, 200, 205);
  doc.text(meta.firm, M, 23);
  doc.text(`${CONTACTS.phone}  ·  ${CONTACTS.email}`, W - M, 16, { align: "right" });
  doc.text(CONTACTS.address, W - M, 23, { align: "right" });

  let y = 50;
  doc.setTextColor(...dim);
  doc.setFontSize(9);
  doc.text(`${meta.calc} · ${new Date().toLocaleDateString(lang === "en" ? "en-GB" : "bg-BG")}`, M, y);
  y += 9;
  doc.setFont("Plex", "bold");
  doc.setFontSize(20);
  doc.setTextColor(...ink);
  doc.text(title, M, y);
  y += 14;

  doc.setFont("Plex", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...dim);
  doc.text(resultLabel.toUpperCase(), M, y);
  y += 11;
  doc.setFont("Plex", "bold");
  doc.setFontSize(26);
  doc.setTextColor(...gold);
  doc.text(mainText, M, y);
  y += 14;

  doc.setDrawColor(220, 220, 224);
  doc.line(M, y, W - M, y);
  y += 8;
  rows.forEach((r) => {
    doc.setFont("Plex", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 66);
    doc.text(r.label, M, y);
    doc.setFont("Plex", "bold");
    doc.setTextColor(...ink);
    doc.text(r.text, W - M, y, { align: "right" });
    y += 4;
    doc.line(M, y, W - M, y);
    y += 8;
  });

  y += 4;
  doc.setFont("Plex", "normal");
  doc.setFontSize(8.5);
  doc.setTextColor(...dim);
  const lines = doc.splitTextToSize(`${note} ${meta.disclaimer}`, W - 2 * M);
  doc.text(lines, M, y);

  doc.setFontSize(8);
  doc.text("rightaccountplovdiv.com", M, 287);
  doc.save(`RightAccount-${title.replace(/[^\p{L}\p{N}]+/gu, "-")}.pdf`);
};

export const requestQuote = ({ title, resultLabel, mainText, rows, service, quoteMsg }) => {
  const message = [quoteMsg(title), "", `${resultLabel}: ${mainText}`, ...rows.map((r) => `• ${r.label}: ${r.text}`)].join("\n");
  window.dispatchEvent(new CustomEvent("calc-quote", { detail: { message, service } }));
};
